/**
 * A rate card's status chip (TMMPDM-0089). The card's own
 * `status` reads as Active (PUBLISHED, success), Draft (outlined: draft only, TMM-B2) or Closed
 * (RETIRED, neutral); a version keeps its own Published / Draft / Retired words.
 */
import type { CustomerRateCardStatus } from '@/api/tmm/types';
import { useCopy } from '@/hooks/useCopy';
import { StatusChip } from '@/status';

export function RateCardStatusChip({ status }: { status: CustomerRateCardStatus }) {
  const { t } = useCopy();
  if (status === 'PUBLISHED') {
    return <StatusChip tone="success" label={t('rateCard.status.active', 'Active')} />;
  }
  if (status === 'RETIRED') {
    return <StatusChip tone="neutral" label={t('rateCard.status.closed', 'Closed')} />;
  }
  return <StatusChip tone="draft" label={t('rateCard.status.draft', 'Draft')} />;
}
